module.exports = __webpack_public_path__ + "img/home-how-it-works.dd993aba.jpg";